"use client"

import * as React from "react";
import Grid from "@mui/material/Grid";
import PIImageManagementAdmin from "./p-i-image-management-admin";
import PPhotoGallery from "./p-photo-gallery";
import PSection from "./p-section";
import PCommentsSection from "./p-comments-section";
import PLabelsSection from "./p-labels-section";
import PInfoSection from "./p-info-section";
import PContentSection from "./p-content-section";
import {Typography} from "@mui/material";
import Container from "@mui/material/Container";
import {Breadcrumb} from "@/components/common/design/breadcrumbs";
import {useProductDetails} from "@/lib/api";
import {PATHS} from "@/utils/paths";
import PPriceChart from "./p-price-chart";
import Box from "@mui/material/Box";
import {useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";


export default function ProductView({params}: { params: any }) {
    const user = useAppSelector((state) => state.user.currentUser);
    const isAdmin = useAppSelector((state: RootState) => state.user.currentUser?.roles?.includes("Admin"));

    const {data: details, mutate: mutateProduct} = useProductDetails(params.id);
    if (!details) return null;

    return (
        <>
            <Breadcrumb fallback = {`${PATHS.GENERAL.PRODUCTS}?isExists=true`} maxWidth = "lg" />

            <Container
                maxWidth = 'lg'
                sx = {{
                    pb: 10
                }}
            >
                <Grid container spacing = {3} >
                    <Grid item xs = {12} sm = {6} md = {0} display = {{xs: "block", sm: "none"}} >
                        <PSection title = "گالری تصاویر" faIcon = "fa-image" >
                            <PPhotoGallery mutateProduct = {mutateProduct} product = {details} />
                        </PSection >
                        <Box pt = {3} />

                        <PInfoSection product = {details} />

                        {
                            isAdmin &&
                            <>
                              <PContentSection title = "مدیریت تصاویر" name = "مدیریت تصاویر"
                                  faIcon = "fa-images" >
                                <PIImageManagementAdmin productId = {params.id} mutateProduct = {mutateProduct} />
                              </PContentSection >
                              <Box pt = {3} />

                            </>

                        }

                        <PContentSection
                            title = " مشاهده نمودار قیمت کالا"
                            name = " مشاهده نمودار قیمت کالا"
                            faIcon = "fa-chart-area"
                        >
                            {user ? (
                                <PPriceChart
                                    productId = {details?.id}
                                    productName = {details?.namePersian + " " + details?.carName}
                                />
                            ) : (
                                <Box
                                    display = "flex"
                                    alignItems = "center"
                                    justifyContent = "center"
                                    py = {2}
                                >
                                    <Typography
                                        fontSize = {14}
                                        color = "text.secondary"
                                        textAlign = "center"
                                    >
                                        برای نمایش نمودار قیمت ابتدا وارد شوید
                                    </Typography >
                                </Box >
                            )}

                        </PContentSection >

                        <Box pt = {3} />

                        <PContentSection
                            faIcon = "fa-file-alt"
                            title = "توضیحات کالا"
                            name = "توضیحات"
                        >
                            <Typography fontSize = {14} color = 'text.secondary' py = {2}
                                textAlign = {details?.description ? "right" : "center"} >
                                {details.description ? details?.description : "توضیحاتی یافت نشد."}
                            </Typography >
                        </PContentSection >

                        <Box pt = {3} />

                        <PContentSection title = " برچسب‌های قطعه" name = " برچسب‌های قطعه" faIcon = "fa-tag" >
                            <PLabelsSection nameAlias = {details?.nameAlias || "برچسبی موجود نیست"} />
                        </PContentSection >

                        <Box pt = {3} />

                        <PCommentsSection mutateProduct = {mutateProduct} productId = {details?.id} comments = {details?.comments || []} />
                    </Grid >

                    {/* Content for Desktop */}
                    <Grid item container spacing = {3} display = {{xs: "none", sm: "flex"}} >
                        <Grid item xs = {7} sm = {7} md = {7} >
                            <PSection title = "گالری تصاویر" faIcon = "fa-image" >
                                <PPhotoGallery mutateProduct = {mutateProduct} product = {details} />
                            </PSection >

                            {
                                isAdmin &&
                                <>
                                  <Box pt = {3} />

                                  <PContentSection title = "مدیریت تصاویر" name = "مدیریت تصاویر"
                                      faIcon = "fa-images" >
                                    <PIImageManagementAdmin productId = {params.id}
                                        mutateProduct = {mutateProduct} />
                                  </PContentSection >
                                </>

                            }

                            <Box pt = {3} />

                            <PContentSection
                                title = " مشاهده نمودار قیمت کالا"
                                name = " مشاهده نمودار قیمت کالا"
                                faIcon = "fa-chart-area"
                            >
                                {user ? (
                                    <PPriceChart
                                        productId = {details?.id}
                                        productName = {details?.namePersian + " " + details?.carName}
                                    />
                                ) : (
                                    <Box
                                        display = "flex"
                                        alignItems = "center"
                                        justifyContent = "center"
                                        py = {2}
                                    >
                                        <Typography
                                            fontSize = {14}
                                            color = "text.secondary"
                                            textAlign = "center"
                                        >
                                            برای نمایش نمودار قیمت ابتدا وارد شوید
                                        </Typography >
                                    </Box >
                                )}

                            </PContentSection >
                            <Box pt = {3} />

                            <PContentSection
                                faIcon = "fa-file-alt"
                                title = "توضیحات کالا"
                                name = "توضیحات"
                            >
                                <Typography fontSize = {14} color = 'text.secondary' py = {2}
                                    textAlign = {details?.description ? "right" : "center"} >
                                    {details.description ? details?.description : "توضیحاتی یافت نشد."}
                                </Typography >

                            </PContentSection >
                            <Box pt = {3} />

                            {/*<PScoreSection productId={details?.id} />*/}
                            <PCommentsSection mutateProduct = {mutateProduct} productId = {details?.id}
                                comments = {details?.comments || []} />

                        </Grid >
                        <Grid item xs = {5} >
                            <PInfoSection product = {details} />

                            <PContentSection title = " برچسب‌های قطعه" name = " برچسب‌های قطعه" faIcon = "fa-tag" >
                                <PLabelsSection nameAlias = {details?.nameAlias || "برچسبی موجود نیست"} />
                            </PContentSection >
                        </Grid >
                    </Grid >
                </Grid >
            </Container >
        </>
    );
}
